export const PHASES = {
	pilot0: 0,
	pilot1: 1,
	pilot2: 2,
	pilot3: 3,
	pilot4: 4,
	fullService: 5,
};
